import { render, staticRenderFns } from "./reservationBoard.vue?vue&type=template&id=dff14e58&scoped=true"
import script from "./reservationBoard.vue?vue&type=script&lang=js"
export * from "./reservationBoard.vue?vue&type=script&lang=js"
import style0 from "./reservationBoard.vue?vue&type=style&index=0&id=dff14e58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff14e58",
  null
  
)

export default component.exports